(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3730],{

/***/ 83730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62062);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(145);
/* harmony import */ var ab_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(276);
/* harmony import */ var react_in_viewport__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28447);
/* harmony import */ var _ab_history_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33311);
/* harmony import */ var _ab_history_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_ab_history_scss__WEBPACK_IMPORTED_MODULE_6__);







var HistoryCard = function(param) {
    var navlink = param.navlink, title = param.title, imagen = param.imagen, animated = param.animated, i18n = param.i18n, contenido = param.contenido, brief = param.brief, rtl = param.rtl, classname = param.classname;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), full = ref[0], setFull = ref[1];
    var myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    var ref1 = (0,react_in_viewport__WEBPACK_IMPORTED_MODULE_5__/* .useInViewport */ .NM)(myRef, {
        threshold: 0.5
    }, {
        onEnterViewport: function() {
        // console.log("entered viewport");
        }
    }, {
        disconnectOnLeave: false
    }), inViewport = ref1.inViewport, enterCount = ref1.enterCount, leaveCount = ref1.leaveCount;
    var handleScroll = function() {
        var element = document.getElementById("menu-#".concat(navlink));
        var menu = document.getElementById("history-menu");
        if (element) {
            if (inViewport) {
                var ref;
                if (!(element === null || element === void 0 ? void 0 : (ref = element.classList) === null || ref === void 0 ? void 0 : ref.contains("selected"))) {
                    var children = menu === null || menu === void 0 ? void 0 : menu.querySelectorAll("li");
                    children.forEach(function(e) {
                        if (e.id !== element.id) {
                            e === null || e === void 0 ? void 0 : e.classList.remove("selected");
                            e === null || e === void 0 ? void 0 : e.classList.add("not-selected");
                        }
                    });
                    element === null || element === void 0 ? void 0 : element.classList.add("selected");
                    element === null || element === void 0 ? void 0 : element.classList.remove("not-selected");
                    menu.scrollLeft = (element === null || element === void 0 ? void 0 : element.offsetLeft) - 10;
                }
            } else {
                var ref1;
                if (!(element === null || element === void 0 ? void 0 : (ref1 = element.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("not-selected"))) {
                    element === null || element === void 0 ? void 0 : element.classList.remove("selected");
                    element === null || element === void 0 ? void 0 : element.classList.add("not-selected");
                }
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        inViewport
    ]);
    var text = full ? contenido : brief;
    // console.log('Historia ', text);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: "reference",
                id: navlink
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "ab-history-card ".concat(classname),
                ref: myRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: rtl ? "rtl" : undefined,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: imagen === null || imagen === void 0 ? void 0 : imagen.mediaItemUrl,
                            alt: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-column",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    element: "h2",
                                    animated: animated,
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    element: "div",
                                    className: "texto",
                                    children: text
                                }),
                                contenido ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    prefetch: false,
                                    text: full ? t("cerrar") : t("leer-mas"),
                                    onClick: function() {
                                        setFull(!full);
                                    }
                                }) : null
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HistoryCard);


/***/ }),

/***/ 33311:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);